import React, { useState, useEffect, useRef } from 'react';
import userIcon from '../img/User-Icon.png';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import '../css/requisition-app-styles.css';



function TopBarIcons() {
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [isMessagesOpen, setMessagesOpen] = useState(false);
  const [isUserInformationOpen, setUserInformationOpen] = useState(false);
  const [fullName, setFullName] = useState('');
  
  const displayPictureFilePath = localStorage.getItem('displayPictureFilePath'); 

  const navigate = useNavigate();

  
  const alertRef = React.useRef();

  const messagesRef = useRef(null); 
  const userInfoRef = useRef(null); 
  
  

  const toggleAlertDropdown = (event) => {
    event.preventDefault();
    setAlertOpen((prevState) => !prevState);
  };

  const toggleMessagesDropdown = (event) => {
    event.preventDefault();
    setMessagesOpen((prevState) => !prevState);
  };

  const toggleUserInformation = (event) => {
    event.preventDefault();
    setUserInformationOpen((prevState) => !prevState);
  };

  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertOpen(false);
    }
    if (messagesRef.current && !messagesRef.current.contains(event.target)) {
      setMessagesOpen(false);
    }
    if (userInfoRef.current && !userInfoRef.current.contains(event.target)) {
      setUserInformationOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    
    const storedFullName = localStorage.getItem('fullName');
    if (storedFullName) {
      setFullName(storedFullName);
    }
    

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); 

  const handleLogout = () => {
    localStorage.setItem('logout', Date.now()); 
    localStorage.removeItem('token'); 
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('theFirstName');
    localStorage.removeItem('theLastName');
    localStorage.removeItem('email');
    localStorage.removeItem('phoneNumber');
    localStorage.removeItem('userType');
    localStorage.removeItem('supervisorName');
    localStorage.removeItem('staffLevel');
    localStorage.removeItem('signatureFilePath');
    localStorage.removeItem('displayPictureFilePath');
  
    navigate('/login');
  };
    



  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const theUserId = localStorage.getItem('userId');  

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve, 300));
        const resp = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/notifications/user/${theUserId}`
        );
        if (!resp.ok) throw new Error("Fetch failed");
  
        const data = await resp.json();
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data.notifications)
          ? data.notifications
          : data.$values || [];
  
        setNotifications(list);
        setUnreadCount(list.filter((n) => !n.isRead).length);
      } catch (err) {
        console.error("Error fetching notifications:", err);
        setNotifications([]);
        setUnreadCount(0);
      }
    };
  
    fetchNotifications();
  }, [theUserId]);
  
  const handleNotificationClick = async (notification) => {
    const requisitionId = notification.requisitionID;
    const notificationType = notification.type;

  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications/mark-as-read/${notification.id}`, {        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (response.ok) {
        setNotifications(prevNotifications =>
          prevNotifications.map(n =>
            n.id === notification.id ? { ...n, isRead: true } : n
          )
        );
  
        setUnreadCount(prevUnreadCount => prevUnreadCount - 1);
      } else {
        console.error('Failed to mark notification as read, status code:', response.status);
      }
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
    console.log("Navigating to requisition ID:", requisitionId);

    

    if (requisitionId) {
      const cleanActionLink = notification.actionLink.replace(/,+$/, ''); 
      console.log('The Cleaned ActionLink:', cleanActionLink);
      if(notificationType !== "Reviewed")
        navigate(cleanActionLink);

    }
  };

  const handleShowAllNotificationClick = async () => {
      console.log("Show All Notifications clicked");
      navigate("/notifications");
  };
  
  
  

  return (
    <ul className="navbar-nav ml-auto">
    {/* Notification Bell */}
    <li className="nav-item dropdown no-arrow mx-1" ref={alertRef}>
      <a className="nav-link dropdown-toggle" href="#" onClick={toggleAlertDropdown}>
        <i className="fas fa-bell fa-fw"></i>
        {unreadCount > 0 && ( 
          <span className="badge badge-danger badge-counter">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </a>

      {isAlertOpen && (
        <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in show custom-dropdown-width">
          <h6 className="dropdown-header">Notifications</h6>
          
          {notifications.slice(0, 3).map((notification, index) => (
            <div key={index}>
              <div className="dropdown-divider"></div>
              <a
                className={`dropdown-item d-flex align-items-center ${!notification.isRead ? 'bg-warning' : ''}`} 
                onClick={() => {
                  handleNotificationClick(notification); 
                }}
                style={{ cursor: "pointer" }}
              >
                {notification.type === 'info-notification' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/${notification.requesterDisplayPicturePath}`} alt="User Icon" />
                </div>
                )}
                {notification.type === 'reviewer-to-reviewer' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/${notification.reviewerDisplayPicturePath}`} alt="User Icon" />
                </div>
                )}
                {notification.type === 'Reviewed' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/${notification.reviewerDisplayPicturePath}`} alt="User Icon" />
                </div>
                )}
                {notification.type === 'disbursed' && (
                <div className="dropdown-list-image mr-3">
                <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/icons/dollar-sign-icon.jpg`} alt="User Icon" />
                </div>
                )}
                {notification.type === 'disburse' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/icons/hand-holding-money.jpg`} alt="User Icon" />
                </div>
                )}
                {notification.type === 'disapproved' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/icons/x-icon.jpg`} alt="User Icon" />
                </div>
                )}
                
                <div className="font-weight-bold">
                  <div className="text-truncate">{notification.title}</div>
                  <div className="small text-gray-500">{notification.message} · 58m</div>
                </div>
              </a>
            </div>
          ))}
          
          <div className="dropdown-divider"></div>
          <a className="dropdown-item text-center small text-gray-500 show-all-notifications-text-area" onClick={() => handleShowAllNotificationClick()}>
            Show All Notifications
          </a>
        </div>
      )}
    </li>  
      
      <div className="topbar-divider d-none d-sm-block"></div>


{/* User Information */}
<li className="nav-item dropdown no-arrow" ref={userInfoRef}>
        <a
          className="nav-link dropdown-toggle"
          href="#"
          id="userDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={toggleUserInformation}
        >
          <span className="mr-2 d-none d-lg-inline text-gray-600 small">
            {fullName || 'Name'}  
          </span>
          <img className="img-profile rounded-circle" src={`${process.env.REACT_APP_STATIC_BASE_URL}/${displayPictureFilePath}`} alt="User Icon" />
        </a>

        {/* Dropdown - User Information */}
        {isUserInformationOpen && (
          <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in show">
            <Link className="dropdown-item d-flex align-items-center" to="/settings">
            <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                Settings
            </Link>
            <div className="dropdown-divider"></div>
            <a className="dropdown-item d-flex align-items-center" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
              Logout
            </a>
          </div>
        )}
      </li>
    </ul>
      );
}

export default TopBarIcons;
